<template>
  <div class="sm-customers-table__popup">
    <h4>Run billing for {{item.full_name}}</h4>
    <datepicker-wrap
      v-model="runData.billing_date"
    />
    <div class="sm-customers-table__popup-flex">
      <btn-block
        :type="'small'"
        :text="'Run'"
        :class="{
          'disabled': !runData.billing_date
        }"
        @click="$emit('run', runData)"
      />
      <btn-block
        :type="'small'"
        :text="'Cancel'"
        :class="'sm-btn--grey'"
        @click="$emit('cancel')"
      />
    </div>
  </div>
</template>

<script>
import DatepickerWrap from '@/components/DatepickerWrap';

export default {
  name: 'run-billing',
  components: {
    'datepicker-wrap': DatepickerWrap
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      runData: {
        id: null,
        billing_date: null
      }
    }
  },
  created() {
    this.runData.id = this.item.id;
  }
}
</script>